module.exports = __webpack_public_path__ + "static/media/ic_cpf_info.8e22701c.svg";